import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSession from 'vue-session'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import * as VueGoogleMaps from 'vue2-google-maps'
import store from './store'
import Moment from 'moment';
import CountryFlag from 'vue-country-flag'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify' // https://github.com/iliyaZelenko/tiptap-vuetify
import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'

import Vuetify from 'vuetify';

Vue.config.productionTip = false;

const axiosBase = axios.create({
  baseURL:'https://aresjson.villaforyou.net/'
});
Vue.prototype.$axios = axiosBase;

Vue.use(VueSession);
Vue.use(Vuetify);
Vue.prototype.$moment = Moment;
Vue.component('country-flag', CountryFlag)
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi'
})

export const bus = new Vue(); // event bus declaration

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

